module.exports = "/packs/images/svg/ireland/facilities/sports~410f13f47eb806ef5fb5d596efb5f4a1.svg";